import { assert_string_object_id, assert_type_enum } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { ENUM__image_asset_category } from '@shared/dto/generation/graph_invoke/_fields/ENUM__image_asset_category';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';

export class DTO_REQUEST__image_asset_filter extends DTO__base {
  /*
   * STATIC FIELDS
   */
  static _class_name_static: string = ENUM__dto_class_name.REQUEST_IMAGE_ASSET_FILTER;

  /*
   * FIELDS
   */
  workspace_id!: string;
  category!: ENUM__image_asset_category;

  /*
   * METHODS
   */

  assert_standard_fields(): void {
    assert_string_object_id(this.workspace_id);

    assert_type_enum(this.category, ENUM__image_asset_category);
  }
}
